import { gql } from 'graphql.macro';
import { webhookSubscriptionFieldsFragment } from 'apollo/fragments/webhook-subscription';

export const getWebhookSubscriptionsForOrganizationTemplate = gql`
    query webhookSubscriptionsForOrganization($organizationId: MongoDbObjectId!) {
        webhookSubscriptionsForOrganization(organizationId: $organizationId) {
            ...webhookSubscriptionFields
        }
    }
    ${webhookSubscriptionFieldsFragment}
`;
